export const config = {
    style: {
        drawerWidth: 240,
    },
    auth: {
        refreshTokenThreshold: 15,
    },
};